import {useEffect, useRef, useState} from 'react';
import {onAuthStateChanged} from 'firebase/auth';
import {useLocation, useNavigate} from 'react-router-dom';
import {auth} from '../../firebaseConfig';

export function notificationDestination(intent, uid, origin, now=Date.now()) {
  if(!intent || !uid || intent.recipientUid!==uid || !Number.isFinite(intent.createdAt) || now-intent.createdAt>300000 || intent.createdAt>now+1000)return '';
  try{const url=new URL(intent.url);if(url.origin!==origin || !['https:','http:'].includes(url.protocol))return '';
    // Only known announcement/team destinations, never arbitrary routes from persisted input.
    if(!/\/(?:app\/teams\/[^/]+(?:\/(?:chat|announcements|meetings|resources|members))?|announcements)$/.test(url.pathname))return '';
    return url.pathname+url.search+url.hash;
  }catch{return '';}
}
export default function NotificationDestinationRecovery(){
  const [uid,setUid]=useState(''),[intent,setIntent]=useState(null);
  const location=useLocation(),navigate=useNavigate(),requested=useRef('');
  useEffect(()=>onAuthStateChanged(auth,user=>{setUid(user?.uid || '');setIntent(null);requested.current='';}),[]);
  useEffect(()=>{
    if(!uid || !navigator.serviceWorker)return undefined;
    let active=true;const ports=new Set();
    const read=async()=>{
      if(document.visibilityState==='hidden')return;
      const registration=await navigator.serviceWorker.getRegistration();
      if(!active || !registration?.active)return;
      const channel=new MessageChannel();ports.add(channel.port1);
      const timer=setTimeout(()=>{channel.port1.close();ports.delete(channel.port1);},2000);
      channel.port1.onmessage=event=>{clearTimeout(timer);channel.port1.close();ports.delete(channel.port1);if(active && auth.currentUser?.uid===uid)setIntent(event.data);};
      registration.active.postMessage({type:'GET_NOTIFICATION_INTENT',uid},[channel.port2]);
    };
    const receive=event=>{if(event.data?.type==='NOTIFICATION_DESTINATION_READY')void read().catch(()=>{});};
    const resume=()=>{void read().catch(()=>{});};
    resume();navigator.serviceWorker.addEventListener('message',receive);document.addEventListener('visibilitychange',resume);
    return ()=>{active=false;ports.forEach(port=>port.close());navigator.serviceWorker.removeEventListener('message',receive);document.removeEventListener('visibilitychange',resume);};
  },[uid]);
  useEffect(()=>{
    const path=notificationDestination(intent,uid,window.location.origin);
    if(!path)return;
    const current=location.pathname+location.search+location.hash;
    if(current===path){
      navigator.serviceWorker?.getRegistration().then(reg=>reg?.active?.postMessage({type:'ACK_NOTIFICATION_INTENT',uid,id:intent.id})).catch(()=>{});
      setIntent(null);return;
    }
    // Route guards still enforce authentication and membership. Do not fight their redirects.
    if(requested.current===intent.id)return;
    requested.current=intent.id;navigate(path);
  },[intent,uid,location,navigate]);
  return null;
}
